/*********************************************************************************************
 * Sets up the cart form submission handler.
 */
function mmSetupProductForm() {
	const forms = document.querySelectorAll("[data-type='add-to-cart-form']");
	if (!forms) return;

	forms.forEach((form) => {
		form.addEventListener("submit", function (event) {
			event.preventDefault();

			const formData = new FormData(form);

			// Avec le panier flottant sur la page (MM-Cart-Drawer), le volet
			// s'ouvre AU CLIC, en état chargement — attendre la réponse
			// réseau pour réagir donnait un temps mort perçu comme un
			// freeze. Le HTML frais de la section revient dans la même
			// réponse via l'API Section Rendering.
			// La voie appartient au FORMULAIRE, plus à la page : depuis que
			// le panier est rendu en statique partout (theme.liquid), le
			// volet peut exister sur une page offre — dont le tunnel doit
			// filer droit au checkout. Un formulaire marqué
			// data-mm-checkout-direct garde donc la redirection historique.
			const direct = form.hasAttribute("data-mm-checkout-direct");
			const drawer = !direct && window.mmCartDrawer && window.mmCartDrawer.exists() ? window.mmCartDrawer : null;
			const submitBtn = form.querySelector('button[type="submit"]');

			// ÉTAT D'ATTENTE SANS [disabled]. Désactiver l'élément qui porte le
			// focus le fait retomber sur <body> : au clavier, l'utilisateur perd
			// sa place. aria-busy + aria-disabled annoncent l'attente et gardent
			// le bouton dans l'ordre de tabulation ; le double envoi est bloqué
			// par le drapeau ci-dessous, plus par le navigateur. WCAG 2.1.1 /
			// 2.4.3. Aucune règle CSS ne vise [disabled] sur .mm-merch__cta :
			// l'apparence pendant la requête est exactement celle d'avant.
			if (form.dataset.mmAddBusy === "1") return;
			form.dataset.mmAddBusy = "1";

			// Vide au repos, visually-hidden : le seul retour parlé d'un échec.
			const errorBox = form.querySelector("[data-mm-add-error]");
			const ERREUR_REPLI = "Impossible d'ajouter cet article au panier. Réessayez ou contactez-nous.";
			if (errorBox) errorBox.textContent = "";

			if (drawer) {
				formData.append("sections", drawer.sectionId());
				formData.append("sections_url", window.location.pathname);
				// le variant permet à l'optimiste de faire grimper la bonne
				// ligne tout de suite ; un variant absent pose une ligne d'attente
				drawer.beginAdd(formData.get("id"));
			}
			if (submitBtn) {
				submitBtn.setAttribute("aria-busy", "true");
				submitBtn.setAttribute("aria-disabled", "true");
			}
			// Posée APRÈS beginAdd() : l'optimiste vient d'écrire la synthèse du
			// panier dans cette même région (recompute), c'est bien « en cours »
			// qu'il faut entendre en premier.
			const annonce = document.querySelector("[data-mm-cart-annonce]");
			if (annonce) annonce.textContent = "Ajout au panier en cours.";

			fetch("/cart/add.js", {
				method: "POST",
				body: formData,
			})
            .then((response) => response.json())
            .then((data) => {
                if (data.status && data.status !== 200) {
                    console.error("Erreur ajout panier :", data.description || data.message);
                    const message = data.description || data.message || ERREUR_REPLI;
                    if (errorBox) errorBox.textContent = message;
                    if (drawer) drawer.addFailed();
                    return;
                }
                if (drawer) {
                    drawer.onAdded(data.sections);
                } else {
                    window.location.href = "/checkout";
                }
            })
            .catch((error) => {
                console.error("Erreur:", error);
                if (errorBox) errorBox.textContent = ERREUR_REPLI;
                if (drawer) drawer.addFailed();
            })
            .finally(() => {
                form.dataset.mmAddBusy = "";
                if (submitBtn) {
                    submitBtn.removeAttribute("aria-busy");
                    submitBtn.removeAttribute("aria-disabled");
                }
            });
		});
	});
}

/*********************************************************************************************
 * Variant Selector
 */
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("change", this.onVariantChange.bind(this));
	}

	onVariantChange() {
		this.updateOptions();
		this.updateVariantId();
		this.updateURL();
		this.updateVariantData();
	}

	updateOptions() {
		this.options = Array.from(
			this.querySelectorAll('input[type="radio"]:checked'),
			(input) => input.value
		);
	}

	updateVariantId() {
		const variants = this.getVariantData();
		const selectedVariant = variants.find((variant) => {
			return variant.options.every((option, index) => {
				return this.options[index] === option;
			});
		});

		if (selectedVariant) {
			const input = document.querySelector('input[name="id"]');
			if (input) {
				input.value = selectedVariant.id;
			}
		}
	}

	updateURL() {
		const variants = this.getVariantData();
		const selectedVariant = variants.find((variant) => {
			return variant.options.every((option, index) => {
				return this.options[index] === option;
			});
		});

		if (selectedVariant) {
			const url = new URL(window.location);
			url.searchParams.set('variant', selectedVariant.id);
			window.history.replaceState({}, '', url);
		}
	}

	getVariantData() {
		const json = this.querySelector('script[type="application/json"]');
		return json ? JSON.parse(json.textContent) : [];
	}

	async updateVariantData() {
		const variants = this.getVariantData();
		const selectedVariant = variants.find((variant) => {
			return variant.options.every((option, index) => {
				return this.options[index] === option;
			});
		});

		if (!selectedVariant) return;

		const sectionId = this.dataset.section;
		const url = this.dataset.url;

		if (!sectionId || !url) return;

		try {
			const response = await fetch(`${url}?variant=${selectedVariant.id}&section_id=${sectionId}`);
			const html = await response.text();
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');

			// Mettre à jour tous les éléments avec data-product-reload
			const elementsToUpdate = document.querySelectorAll('[data-product-reload]');
			elementsToUpdate.forEach((element) => {
				const newElement = doc.querySelector(`[data-product-reload="${element.dataset.productReload}"]`);
				if (newElement) {
					element.innerHTML = newElement.innerHTML;
				}
			});
		} catch (error) {
			console.error('Erreur lors de la mise à jour des données variant:', error);
		}
	}
}

customElements.define('variant-selector', VariantSelector);

document.addEventListener("DOMContentLoaded", (event) => {
	mmSetupProductForm();
});